import { Component, EventEmitter, Input, Output, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Fountain } from '../../../models/Fountain';
import { SourceService } from '../../../service/source.service';

@Component({
  selector: 'app-modal-delete-source',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-delete-source.html',
  styleUrls: ['./modal-delete-source.scss']
})
export class ModalDeleteSource {
  @Input() fountain: Fountain | null = null;
  @Output() deleted = new EventEmitter<void>();

  private sourceService = inject(SourceService);

  // 🧠 Signals en lugar de variables simples
  loading = signal(false);
  success = signal(false);
  error = signal(false);

  confirmDelete(): void {
    if (!this.fountain) return;
    const id = this.fountain.pk ?? this.fountain.id;
    if (!id) return;

    this.loading.set(true);

    this.sourceService.delete(id).subscribe({
      next: () => {
        this.loading.set(false);
        this.success.set(true);
        this.deleted.emit();

        // Cierra automáticamente luego de 1.5 s
        setTimeout(() => this.closeModal(), 1500);
      },
      error: () => {
        this.loading.set(false);
        this.error.set(true);
        setTimeout(() => this.closeModal(), 2000);
      }
    });
  }

  private closeModal(): void {
    const modalEl = document.getElementById('deleteModal');
    if (modalEl) {
      const modalInstance = (window as any).bootstrap.Modal.getInstance(modalEl);
      modalInstance?.hide();
    }
  }
}
